import { render, staticRenderFns } from "./CrmPoolSettings.vue?vue&type=template&id=dc590830"
import script from "./CrmPoolSettings.vue?vue&type=script&lang=js"
export * from "./CrmPoolSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports